import { notifications } from '@mantine/notifications';
import { IconX } from '@tabler/icons-react';

export const notifyError = (title: string, message?: string) => {
  notifications.show({
    title,
    message,
    color: 'red',
    icon: <IconX size={18} />,
    autoClose: 3000,
  });
};
